// extracted by mini-css-extract-plugin
module.exports = {"root":"PatientQuestionnaire_root__3z9sM","header":"PatientQuestionnaire_header__2XhmU","info":"PatientQuestionnaire_info__1rQlS"};